import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RsvpStatusSchema } from '../lib/types';

const Search = z.object({
  status: RsvpStatusSchema.catch('maybe'),
  character: z.string().catch(''),
});

export const Route = createFileRoute('/confirmation')({
  validateSearch: Search.parse,
  component: ConfirmationPage,
});

function ConfirmationPage() {
  const { status, character } = Route.useSearch();

  return (
    <div className="smash-stage">
      <div className="smash-panel">
        {status === 'coming' && (
          <>
            <p>You're confirmed.</p>
            {character ? (
              <p>Your character: <strong>{character}</strong>. See you at the tournament!</p>
            ) : (
              <p>See you at the tournament!</p>
            )}
          </>
        )}
        {status === 'not_coming' && <p>Thanks for letting us know. We'll miss you!</p>}
        <button type="button" onClick={() => (window.location.href = '/')}>Back to invitation</button>
      </div>
    </div>
  );
}
